module.exports = __webpack_public_path__ + "img/km_29.2792bacd.jpeg";